var Actions;
(function (Actions) {
    Actions["GET_FUNCTION_LIST"] = "getFunctionListData";
    Actions["GET_FUNCTION_LIST_ALLDATA"] = "getFunctionListAllData";
    Actions["UPDATE_FUNCTION_PAGE_FILTER"] = "updateFunctionPageFilter";
    Actions["UPDATE_FUNCTION_SIZE"] = "updateFunctionSize";
    Actions["UPDATE_FUNCTION_CODE"] = "updateFunctionCode";
    Actions["UPDATE_FUNCTION_DESC"] = "updateFunctionDesc";
})(Actions || (Actions = {}));
var Mutations;
(function (Mutations) {
    // Function for menu mapping project
    Mutations["SET_FUNCTION_LOAD"] = "setFunctionWasFirstLoad";
    Mutations["SET_FUNCTION_LIST"] = "setFunctionList";
    Mutations["SET_FUNCTION_HANDLE_PAGE"] = "setFunctionHandlePage";
    Mutations["SET_FUNCTION_PAGE"] = "setFunctionPage";
    Mutations["SET_FUNCTION_LOAD_PAGE"] = "setFunctionLoadPage";
    Mutations["SET_FUNCTION_LOADING"] = "setFunctionLoading";
    Mutations["SET_FUNCTION_STATUS"] = "setFunctionStatus";
    Mutations["SET_SELECTED_FUNCTION_NAME"] = "setSelectedFunctionName";
    Mutations["SET_DROPDOWNLIST_FUNCTION_CODE"] = "setDropdownlistFunctionCode";
    Mutations["SET_DROPDOWNLIST_FUNCTION_NAME"] = "setDropdownlistFunctionName";
    Mutations["SET_FUNCTION_SIZE"] = "setFunctionSize";
    Mutations["SET_FUNCTION_HANDLE_SIZE"] = "setFunctionHandleSize";
    Mutations["SET_FUNCTION_PAGE_FILTER"] = "setFunctionPageFilter";
    Mutations["SET_FUNCTION_WAS_LOAD_QUICK_FILTER"] = "setFunctionWasLoadQuickFilter";
    Mutations["SET_FUNCTION_DESC"] = "setFunctionSelectedDesc";
    Mutations["SET_FUNCTION_SEARCH_BY"] = "setFunctionSelectedSearchBy";
})(Mutations || (Mutations = {}));
export { Actions, Mutations };
